<div class="dialog-principal">
    <div class="custom-dialog-content">
        <div mat-dialog-content>{{message}}</div>
        <!-- <div mat-dialog-content>Sesión renovada</div> -->
    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="clickCancelar()" class="mat-button mat-primary" class="BotonAgregar"
            color="primary">Aceptar</button>
    </div>
</div>